export class BaseModel {
	id?: string
	tenantId?: string
	created?: string
	updated?: string
	deleted?: string
	term?: string | null
	[key: string]: any

	value?: any
	label?: string
	submitted?: boolean
	reporting?: boolean
	deleting?: boolean
	updating?: boolean
	downloading?: boolean

	constructor(source?: any) {
		if (source) {
			this.id = source.id
			this.term = source.term
			this.created = source.created
			this.deleted = source.deleted
			this.deleting = source.deleting
			this.tenantId = source?.tenantId
		}
	}
}
